module.exports = __webpack_public_path__ + "img/logo-farm-v1.59f3b50b.png";